function sliderValuesCarousel() {
    document.querySelectorAll('.values_carousel_swiper-js').forEach(function(swiperContainer) {
        new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
        });
    });
}

$(function() {
    sliderValuesCarousel();
});
